import { strings } from '@/strings'
import type { DroppedFeature } from '@/types/drafts'

/**
 * User-facing copy for one reason a stash draft cannot be edited in place.
 *
 * The import confirmation renders whatever `classifyDraft` returns — it must never hardcode a
 * fixed list of cases. The `default` arm is a deliberate honest fallback so a `DroppedFeatureKind`
 * added later (e.g. for a new lexicon field) still renders something rather than nothing.
 */
export function droppedFeatureLabel(feature: DroppedFeature): string {
    const copy = strings.drafts.dropped
    switch (feature.kind) {
        case 'additionalPosts':
            return copy.additionalPosts(feature.count ?? 0)
        case 'images':
            return copy.images(feature.count ?? 0)
        case 'surplusExternalEmbeds':
            return copy.surplusExternalEmbeds(feature.count ?? 0)
        case 'surplusRecordEmbeds':
            return copy.surplusRecordEmbeds(feature.count ?? 0)
        case 'video':
            return copy.video
        case 'selfLabels':
            return copy.selfLabels
        case 'languages':
            return copy.languages
        case 'threadgateRules':
            return copy.threadgateRules
        case 'postgateRules':
            return copy.postgateRules
        case 'unsupportedEmbedTarget':
            return copy.unsupportedEmbedTarget
        case 'recordEmbedMissingCid':
            return copy.recordEmbedMissingCid
        case 'malformedExternalUri':
            return copy.malformedExternalUri
        case 'unknownFields':
        default:
            return copy.unknownFields
    }
}

/** Reasons to show in the import confirmation's "this copy won't include" list. */
export function lossReasons(features: DroppedFeature[]): string[] {
    return features.map(droppedFeatureLabel)
}
